import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticateService } from './authenticate.service';

@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(private authService: AuthenticateService, private router: Router) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const url = state.url;
        var transaction = this.authService.getTransactionInfo();
        if (url == '/booking-process/disclaimer' && !transaction) {
            return true;
        }
        if (url == '/booking-process/personal-details' && transaction && !transaction.CustomerId) {
            return true;
        }
        if (url == '/booking-process/flat-availability' && transaction && transaction.CustomerId && !transaction.FlatId) {
            return true;
        }
        if (url == '/booking-process/payment-summary' && transaction && transaction.CustomerId && transaction.FlatId) {
            return true;
        }        
         if (url == '/cc-avenue' && transaction && transaction.CustomerId && transaction.FlatId) {
            return true;
        }  
        this.authService.setRedirectUrl(url);
        if (!transaction) {
           this.router.navigate([this.authService.getLoginUrl()]);
        }
        // else if (!transaction.CustomerId) {
        //     this.router.navigate(['/booking-process/personal-details']);
        // }
        // else if (!transaction.FlatId) {
        //     this.router.navigate(['/booking-process/flat-availability']);
        // }   
        
        return false;
    }
}
